import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

import { hidePasswordChangeModal, showFailedPasswordChangeModal } from './passwordChangeModal';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';

function requestPasswordChange() {
  return {
    type: CHANGE_PASSWORD_REQUEST
  };
}

export function userPasswordChange(username, data) {
  const updateData = new FormData();
  updateData.append('userName', username);
  updateData.append('newPassword', data.newPwd);
  updateData.append('confirmPassword', data.confirmPwd);

  return (dispatch) => {
    dispatch(requestPasswordChange());

    const promise = () => ApiService
      .updatePassword(updateData)
      .then((response) => {
        dispatch(hidePasswordChangeModal());
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, showFailedPasswordChangeModal));
        }
      });
    return promise();
  };
}
